// Records管理用の定数定義

export enum RecordActionTypes {
  // 共通
  SET_CURRENT_USER = 'RECORDS_SET_CURRENT_USER',
  RESET = 'RECORDS_RESET',
  API_ERROR = 'RECORDS_API_ERROR',

  // レコード種別選択画面用（件数取得）
  FETCH_ALL_COUNTS_START = 'RECORDS_FETCH_ALL_COUNTS_START',
  FETCH_ALL_COUNTS_FINISH = 'RECORDS_FETCH_ALL_COUNTS_FINISH',

  // Yoga
  YOGA_START_FETCH = 'RECORDS_YOGA_START_FETCH',
  YOGA_FINISH_FETCH = 'RECORDS_YOGA_FINISH_FETCH',
  YOGA_START_FETCH_ONE = 'RECORDS_YOGA_START_FETCH_ONE',
  YOGA_FINISH_FETCH_ONE = 'RECORDS_YOGA_FINISH_FETCH_ONE',
  YOGA_START_CREATE = 'RECORDS_YOGA_START_CREATE',
  YOGA_FINISH_CREATE = 'RECORDS_YOGA_FINISH_CREATE',
  YOGA_START_UPDATE = 'RECORDS_YOGA_START_UPDATE',
  YOGA_FINISH_UPDATE = 'RECORDS_YOGA_FINISH_UPDATE',
  YOGA_START_DELETE = 'RECORDS_YOGA_START_DELETE',
  YOGA_FINISH_DELETE = 'RECORDS_YOGA_FINISH_DELETE',
  YOGA_RESET_FLAGS = 'RECORDS_YOGA_RESET_FLAGS',

  // HomeVisit
  HOMEVISIT_START_FETCH = 'RECORDS_HOMEVISIT_START_FETCH',
  HOMEVISIT_FINISH_FETCH = 'RECORDS_HOMEVISIT_FINISH_FETCH',
  HOMEVISIT_START_FETCH_ONE = 'RECORDS_HOMEVISIT_START_FETCH_ONE',
  HOMEVISIT_FINISH_FETCH_ONE = 'RECORDS_HOMEVISIT_FINISH_FETCH_ONE',
  HOMEVISIT_START_CREATE = 'RECORDS_HOMEVISIT_START_CREATE',
  HOMEVISIT_FINISH_CREATE = 'RECORDS_HOMEVISIT_FINISH_CREATE',
  HOMEVISIT_START_UPDATE = 'RECORDS_HOMEVISIT_START_UPDATE',
  HOMEVISIT_FINISH_UPDATE = 'RECORDS_HOMEVISIT_FINISH_UPDATE',
  HOMEVISIT_START_DELETE = 'RECORDS_HOMEVISIT_START_DELETE',
  HOMEVISIT_FINISH_DELETE = 'RECORDS_HOMEVISIT_FINISH_DELETE',
  HOMEVISIT_RESET_FLAGS = 'RECORDS_HOMEVISIT_RESET_FLAGS',

  // Interest
  INTEREST_START_FETCH = 'RECORDS_INTEREST_START_FETCH',
  INTEREST_FINISH_FETCH = 'RECORDS_INTEREST_FINISH_FETCH',
  INTEREST_START_FETCH_ONE = 'RECORDS_INTEREST_START_FETCH_ONE',
  INTEREST_FINISH_FETCH_ONE = 'RECORDS_INTEREST_FINISH_FETCH_ONE',
  INTEREST_START_CREATE = 'RECORDS_INTEREST_START_CREATE',
  INTEREST_FINISH_CREATE = 'RECORDS_INTEREST_FINISH_CREATE',
  INTEREST_START_UPDATE = 'RECORDS_INTEREST_START_UPDATE',
  INTEREST_FINISH_UPDATE = 'RECORDS_INTEREST_FINISH_UPDATE',
  INTEREST_START_DELETE = 'RECORDS_INTEREST_START_DELETE',
  INTEREST_FINISH_DELETE = 'RECORDS_INTEREST_FINISH_DELETE',
  INTEREST_RESET_FLAGS = 'RECORDS_INTEREST_RESET_FLAGS',

  // MCI
  MCI_START_FETCH = 'RECORDS_MCI_START_FETCH',
  MCI_FINISH_FETCH = 'RECORDS_MCI_FINISH_FETCH',
  MCI_START_FETCH_ONE = 'RECORDS_MCI_START_FETCH_ONE',
  MCI_FINISH_FETCH_ONE = 'RECORDS_MCI_FINISH_FETCH_ONE',
  MCI_START_CREATE = 'RECORDS_MCI_START_CREATE',
  MCI_FINISH_CREATE = 'RECORDS_MCI_FINISH_CREATE',
  MCI_START_UPDATE = 'RECORDS_MCI_START_UPDATE',
  MCI_FINISH_UPDATE = 'RECORDS_MCI_FINISH_UPDATE',
  MCI_START_DELETE = 'RECORDS_MCI_START_DELETE',
  MCI_FINISH_DELETE = 'RECORDS_MCI_FINISH_DELETE',
  MCI_RESET_FLAGS = 'RECORDS_MCI_RESET_FLAGS',

  // LifeCheck
  LIFECHECK_START_FETCH = 'RECORDS_LIFECHECK_START_FETCH',
  LIFECHECK_FINISH_FETCH = 'RECORDS_LIFECHECK_FINISH_FETCH',
  LIFECHECK_START_FETCH_ONE = 'RECORDS_LIFECHECK_START_FETCH_ONE',
  LIFECHECK_FINISH_FETCH_ONE = 'RECORDS_LIFECHECK_FINISH_FETCH_ONE',
  LIFECHECK_START_CREATE = 'RECORDS_LIFECHECK_START_CREATE',
  LIFECHECK_FINISH_CREATE = 'RECORDS_LIFECHECK_FINISH_CREATE',
  LIFECHECK_START_UPDATE = 'RECORDS_LIFECHECK_START_UPDATE',
  LIFECHECK_FINISH_UPDATE = 'RECORDS_LIFECHECK_FINISH_UPDATE',
  LIFECHECK_START_DELETE = 'RECORDS_LIFECHECK_START_DELETE',
  LIFECHECK_FINISH_DELETE = 'RECORDS_LIFECHECK_FINISH_DELETE',
  LIFECHECK_RESET_FLAGS = 'RECORDS_LIFECHECK_RESET_FLAGS',

  // Barthel
  BARTHEL_START_FETCH = 'RECORDS_BARTHEL_START_FETCH',
  BARTHEL_FINISH_FETCH = 'RECORDS_BARTHEL_FINISH_FETCH',
  BARTHEL_START_FETCH_ONE = 'RECORDS_BARTHEL_START_FETCH_ONE',
  BARTHEL_FINISH_FETCH_ONE = 'RECORDS_BARTHEL_FINISH_FETCH_ONE',
  BARTHEL_START_CREATE = 'RECORDS_BARTHEL_START_CREATE',
  BARTHEL_FINISH_CREATE = 'RECORDS_BARTHEL_FINISH_CREATE',
  BARTHEL_START_UPDATE = 'RECORDS_BARTHEL_START_UPDATE',
  BARTHEL_FINISH_UPDATE = 'RECORDS_BARTHEL_FINISH_UPDATE',
  BARTHEL_START_DELETE = 'RECORDS_BARTHEL_START_DELETE',
  BARTHEL_FINISH_DELETE = 'RECORDS_BARTHEL_FINISH_DELETE',
  BARTHEL_RESET_FLAGS = 'RECORDS_BARTHEL_RESET_FLAGS',

  // MoffTraining (モフトレ)
  MOFFTRAINING_START_FETCH = 'RECORDS_MOFFTRAINING_START_FETCH',
  MOFFTRAINING_FINISH_FETCH = 'RECORDS_MOFFTRAINING_FINISH_FETCH',
  MOFFTRAINING_START_FETCH_ONE = 'RECORDS_MOFFTRAINING_START_FETCH_ONE',
  MOFFTRAINING_FINISH_FETCH_ONE = 'RECORDS_MOFFTRAINING_FINISH_FETCH_ONE',
  MOFFTRAINING_START_CREATE = 'RECORDS_MOFFTRAINING_START_CREATE',
  MOFFTRAINING_FINISH_CREATE = 'RECORDS_MOFFTRAINING_FINISH_CREATE',
  MOFFTRAINING_START_UPDATE = 'RECORDS_MOFFTRAINING_START_UPDATE',
  MOFFTRAINING_FINISH_UPDATE = 'RECORDS_MOFFTRAINING_FINISH_UPDATE',
  MOFFTRAINING_START_DELETE = 'RECORDS_MOFFTRAINING_START_DELETE',
  MOFFTRAINING_FINISH_DELETE = 'RECORDS_MOFFTRAINING_FINISH_DELETE',
  MOFFTRAINING_RESET_FLAGS = 'RECORDS_MOFFTRAINING_RESET_FLAGS',
}

// レコード種別
export type RecordType =
  | 'moffcheck'
  | 'mofftraining'
  | 'yoga'
  | 'homevisit'
  | 'interest'
  | 'mci'
  | 'lifecheck'
  | 'barthel';

export const RecordTypeNames: Record<RecordType, string> = {
  moffcheck: 'モフトレチェック',
  mofftraining: 'モフトレ',
  yoga: 'ADLヨガ',
  homevisit: '訪問記録',
  interest: '興味関心チェック',
  mci: 'MCIテスト',
  lifecheck: '生活機能チェック',
  barthel: 'バーセルインデックス',
};

// ADLヨガ
export interface YogaRecord {
  unique_id: string;
  record_time: string; // "YYYY-MM-DD HH:mm:ss"
  menu_id: number;
  menu_name?: string;
  category_name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface YogaMenu {
  id: number;
  menu_name: string;
  category_name: string;
}

// 訪問記録 - 評価項目の構造
export interface HomeVisitElement {
  level: number[]; // 自立度レベル: 0=自立, 1=見守り, 2=一部介助, 3=全介助
  is_problem: boolean; // 問題の有無
  env?: string; // 環境・備考
}

// 訪問記録
export interface HomeVisitRecord {
  unique_id: string;
  sequence: number;

  // 訪問情報
  staff?: string; // スタッフ名
  profession?: string; // 職種
  visited_day?: string; // 訪問日時 "yyyy-MM-dd HH:mm-HH:mm"
  interviewee?: string; // 聴取対象者

  // ADL（日常生活動作）
  adl_feed?: HomeVisitElement; // 食事
  adl_ur?: HomeVisitElement; // 排泄
  adl_bath?: HomeVisitElement; // 入浴
  adl_dress?: HomeVisitElement; // 更衣
  adl_cosme?: HomeVisitElement; // 整容
  adl_transfer?: HomeVisitElement; // 移乗
  adl_detail?: string; // ADL詳細・備考

  // IADL（手段的日常生活動作）
  iadl_indoor?: HomeVisitElement; // 屋内移動
  iadl_outdoor?: HomeVisitElement; // 屋外移動
  iadl_lift?: HomeVisitElement; // 階段昇降
  iadl_cook?: HomeVisitElement; // 調理
  iadl_wash?: HomeVisitElement; // 洗濯
  iadl_clean?: HomeVisitElement; // 掃除
  iadl_detail?: string; // IADL詳細・備考

  // 居宅内動作
  behaivior_arise?: HomeVisitElement; // 起き上がり
  behaivior_sitting?: HomeVisitElement; // 座位
  behaivior_standup?: HomeVisitElement; // 立ち上がり
  behaivior_upright?: HomeVisitElement; // 立位
  behaivior_detail?: string; // 居宅内動作詳細・備考

  // タイムスタンプ
  created_at?: string;
  updated_at?: string;
}

// 興味関心チェック - 各項目の回答形式
export interface InterestCheckItem {
  do?: boolean;
  want?: boolean;
  interested?: boolean;
}

// 興味関心チェック - 自由記述項目
export interface InterestCheckOtherItem {
  column?: string;
  check?: InterestCheckItem;
}

// 興味関心チェック - 追加項目コンテナ
export interface InterestCheckAdditionalItems {
  other1?: InterestCheckOtherItem;
  other2?: InterestCheckOtherItem;
  other3?: InterestCheckOtherItem;
  other4?: InterestCheckOtherItem;
}

// 興味関心チェック
export interface InterestCheckRecord {
  unique_id: string;
  sequence: number;
  visited_day?: string;
  // 日常生活動作
  toilet?: InterestCheckItem;
  bathing?: InterestCheckItem;
  wearing?: InterestCheckItem;
  eating?: InterestCheckItem;
  brushing?: InterestCheckItem;
  grooming?: InterestCheckItem;
  sleeping?: InterestCheckItem;
  cleaning?: InterestCheckItem;
  // 家事・実用的活動
  cooking?: InterestCheckItem;
  shopping?: InterestCheckItem;
  gardening?: InterestCheckItem;
  laundering?: InterestCheckItem;
  driving?: InterestCheckItem;
  outing?: InterestCheckItem;
  // 社会・家族関係
  children?: InterestCheckItem;
  animal?: InterestCheckItem;
  friends?: InterestCheckItem;
  family?: InterestCheckItem;
  dating?: InterestCheckItem;
  drinking?: InterestCheckItem;
  // 地域・社会活動
  volunteer?: InterestCheckItem;
  community_activity?: InterestCheckItem;
  religion?: InterestCheckItem;
  lifelong_learning?: InterestCheckItem;
  // 文化・芸術活動
  reading?: InterestCheckItem;
  haiku?: InterestCheckItem;
  shodo?: InterestCheckItem;
  painting?: InterestCheckItem;
  typing?: InterestCheckItem;
  photo?: InterestCheckItem;
  theater?: InterestCheckItem;
  sado_kado?: InterestCheckItem;
  singing?: InterestCheckItem;
  // 音楽・娯楽
  music?: InterestCheckItem;
  gaming?: InterestCheckItem;
  exercising?: InterestCheckItem;
  strolling?: InterestCheckItem;
  // スポーツ・レクリエーション
  playing_sports?: InterestCheckItem;
  dancing?: InterestCheckItem;
  watching_sports?: InterestCheckItem;
  gambling?: InterestCheckItem;
  knitting?: InterestCheckItem;
  // 手工芸・労働
  sewing?: InterestCheckItem;
  cropping?: InterestCheckItem;
  earning?: InterestCheckItem;
  // 旅行
  traveling?: InterestCheckItem;
  // 自由記述
  additional_item?: InterestCheckAdditionalItems;
  // タイムスタンプ
  created_at?: string;
  updated_at?: string;
}

// MCIテスト
export interface MCITestRecord {
  unique_id: string;
  timestamp: number; // Unix timestamp in milliseconds
  answers: number[]; // 5つの質問の回答スコア [Q1, Q2, Q3, Q4, Q5]
  created_at?: string;
  updated_at?: string;
}

// 生活機能チェック要素
export interface LifeCheckElement {
  level: number[];
  is_problem: boolean;
  env?: string;
}

// 生活機能チェック
export interface LifeCheckRecord {
  unique_id: string;
  sequence: number;
  // 訪問情報
  staff?: string;
  profession?: string;
  visited_time_start?: string;
  visited_time_end?: string;
  interviewee?: string;
  // ADL項目
  adl_feeding?: LifeCheckElement;
  adl_transfers?: LifeCheckElement;
  adl_grooming?: LifeCheckElement;
  adl_toilet_use?: LifeCheckElement;
  adl_bathing?: LifeCheckElement;
  adl_mobility?: LifeCheckElement;
  adl_stairs?: LifeCheckElement;
  adl_dressing?: LifeCheckElement;
  adl_bowels?: LifeCheckElement;
  adl_bladder?: LifeCheckElement;
  adl_detail?: string;
  // IADL項目
  iadl_cooking?: LifeCheckElement;
  iadl_cleaning?: LifeCheckElement;
  iadl_washing?: LifeCheckElement;
  iadl_detail?: string;
  // 居宅内動作
  behavior_turn_over?: LifeCheckElement;
  behavior_raise_up?: LifeCheckElement;
  behavior_sitting?: LifeCheckElement;
  behavior_stand_up?: LifeCheckElement;
  behavior_upright?: LifeCheckElement;
  behavior_detail?: string;
  // タイムスタンプ
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

// バーセルインデックス
export interface BarthelRecord {
  unique_id: string;
  record_time: string; // date (YYYY-MM-DD)
  feeding?: number;
  transfers?: number;
  grooming?: number;
  toilet_use?: number;
  bathing?: number;
  mobility?: number;
  stairs?: number;
  dressing?: number;
  bowels?: number;
  bladder?: number;
  total_score?: number;
  created_at?: string;
  updated_at?: string;
}

// モフトレ（トレーニングログ）
export type DominantHand = 'Right' | 'Left';

export interface MoffTrainingRecord {
  user_id: string;
  training_id: number;
  started_at: string; // yyyy-mm-dd HH:MM:SS
  ended_at?: string;
  count?: number;
  average_angle?: number;
  average_duration?: number;
  initial_angle?: number;
  target_angle?: number;
  angles?: number[];
  absolute_angles?: number[];
  durations?: number[];
  dominant_hand?: DominantHand;
  with_band?: boolean;
  created_at?: string;
  updated_at?: string;
}

// トレーニング種目マスタ
export interface TrainingMenu {
  id: number;
  name: string;
  type: 'adl' | 'locomo';
}

// トレーニング種目マスタデータ（ADL/Locomo）
export const TRAINING_MENUS: TrainingMenu[] = [
  // Locomo系 (ID: 1-21)
  { id: 1, name: 'うで上げ下ろし', type: 'locomo' },
  { id: 2, name: 'うで左右', type: 'locomo' },
  { id: 3, name: 'ひざのばし', type: 'locomo' },
  { id: 4, name: 'ももあげ', type: 'locomo' },
  { id: 5, name: 'また開く閉じる', type: 'locomo' },
  { id: 6, name: 'あし横あげ', type: 'locomo' },
  { id: 7, name: 'おしり', type: 'locomo' },
  { id: 8, name: '上部腹筋', type: 'locomo' },
  { id: 9, name: 'ローイング', type: 'locomo' },
  { id: 10, name: '腕伸ばし', type: 'locomo' },
  { id: 11, name: '股関節外ひねり', type: 'locomo' },
  { id: 12, name: 'アームカール', type: 'locomo' },
  { id: 13, name: 'からだ捻り', type: 'locomo' },
  { id: 14, name: 'レッグカール', type: 'locomo' },
  { id: 15, name: '前腕ひねり', type: 'locomo' },
  { id: 16, name: 'カーフレイズ', type: 'locomo' },
  { id: 17, name: '腹斜筋', type: 'locomo' },
  { id: 18, name: '座位ステップ', type: 'locomo' },
  { id: 19, name: 'アキレス腱', type: 'locomo' },
  { id: 20, name: '肩の外転', type: 'locomo' },
  { id: 21, name: 'よこ腹筋', type: 'locomo' },
  // ADL系 (ID: 101-118)
  { id: 101, name: 'お風呂またぎ', type: 'adl' },
  { id: 102, name: 'お風呂洗髪', type: 'adl' },
  { id: 103, name: 'トイレ立ち上がり', type: 'adl' },
  { id: 104, name: 'トイレ着脱衣', type: 'adl' },
  { id: 107, name: '移動歩行', type: 'adl' },
  { id: 108, name: '洗濯物干し', type: 'adl' },
  { id: 109, name: '段差昇降', type: 'adl' },
  { id: 110, name: '移動下肢支持', type: 'adl' },
  { id: 111, name: '食事口に運ぶ', type: 'adl' },
  { id: 112, name: '整容洗顔', type: 'adl' },
  { id: 113, name: '調理切る', type: 'adl' },
  { id: 114, name: '立位バランス', type: 'adl' },
  { id: 115, name: '更衣上衣', type: 'adl' },
  { id: 116, name: '更衣下衣', type: 'adl' },
  { id: 117, name: '更衣靴下①', type: 'adl' },
  { id: 118, name: '更衣靴下②', type: 'adl' },
];

// 各レコードタイプのサブステート
export interface RecordSubState<T> {
  list: T[];
  current: T | null;
  executing: boolean;
  loaded: boolean;
  created: boolean;
  updated: boolean;
  deleted: boolean;
}

// レコード件数
export interface RecordCounts {
  moffcheck: number;
  mofftraining: number;
  yoga: number;
  homevisit: number;
  interest: number;
  mci: number;
  lifecheck: number;
  barthel: number;
  loading: boolean;
}

// 現在選択中のユーザー
export interface CurrentUserInfo {
  unique_id: string | null;
  userId: string | null;
  userName: string | null;
  institutionId: string | null;
  institutionName: string | null;
}

// Records State全体
export interface RecordsState {
  currentUser: CurrentUserInfo;
  counts: RecordCounts;
  yoga: RecordSubState<YogaRecord>;
  yogaMenus: YogaMenu[];
  homevisit: RecordSubState<HomeVisitRecord>;
  interest: RecordSubState<InterestCheckRecord>;
  mci: RecordSubState<MCITestRecord>;
  lifecheck: RecordSubState<LifeCheckRecord>;
  barthel: RecordSubState<BarthelRecord>;
  mofftraining: RecordSubState<MoffTrainingRecord>;
  trainingMenus: TrainingMenu[];
  error: Error | null;
}

// エラーメッセージマッピング
export const ERROR_MESSAGES: Record<number, string> = {
  400: '入力内容に誤りがあります',
  401: '認証に失敗しました。再ログインしてください',
  403: 'この操作を行う権限がありません',
  404: 'レコードが見つかりません',
  409: '既に同じレコードが存在します',
  500: 'サーバーエラーが発生しました',
};
